module.exports = __webpack_public_path__ + "static/media/storee_man_yellow.03c761a0.png";